import { useDisclosure } from "@heroui/react";

import { Typography } from "@cpj-ai/panel-npm-package";
import TermsAndConditionModal from "@modules/Auth/components/TermsAndConditionModal";

const TermOfUseLabel = () => {
  const { isOpen, onOpen, onClose, onOpenChange } = useDisclosure();
  const handleOpenModal = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onOpen();
  };

  return (
    <>
      <TermsAndConditionModal isOpen={isOpen} onClose={onClose} onOpenChange={onOpenChange} />
      <Typography variant="muted">
        By registering you agree to the CPJ{" "}
        <span className="text-foreground-900 underline cursor-pointer z-10 relative" onClick={handleOpenModal}>
          Terms of Use
        </span>
      </Typography>
    </>
  );
};

export default TermOfUseLabel;
